export default __webpack_public_path__ + "static/media/fruit-1024w.adeee976.webp";